import { ButtonProps } from "@chakra-ui/react";
import { AuthButton, SignInButton } from "./auth-button";
import { ButtonLink, ButtonLink_T } from "./button-link";
import { ButtonOpenModal, ButtonOpenModal_T } from "./open-modal";
import { ButtonOpenSearch_T } from "./open-search";
import { getWebUrl } from "@areahub/config";

export type Button_T =
  | ({ __type: "LINK" } & ButtonLink_T & { label?: string })
  | ({ __type: "OPEN_SEARCH" } & ButtonOpenSearch_T & { label?: string })
  | ({ __type: "OPEN_MODAL" } & ButtonLink_T & { label?: string })
  | ({ __type: "AUTH" } & ButtonProps & { label?: string });

export type ButtonActions = "AUTH" | "LINK" | "OPEN_MODAL" | "OPEN_SEARCH";

const buttonStyle = {
  borderRadius: "full",
};

export const Button = (props: Button_T) => {
  const { __type, label, ...rest } = props;
  const parsedProps = { ...rest, children: label };

  switch (__type) {
    case "LINK":
      return <ButtonLink {...buttonStyle} {...(parsedProps as ButtonLink_T)} />;
    case "OPEN_SEARCH":
      return (
        <ButtonLink
          {...buttonStyle}
          {...(parsedProps as ButtonLink_T)}
          href={getWebUrl() + "/individuals/pricing"}
        />
      );
    case "OPEN_MODAL":
      return (
        <ButtonOpenModal
          {...buttonStyle}
          {...(parsedProps as ButtonOpenModal_T)}
        />
      );
    case "AUTH":
      if (process.env.APP_NAME === "PREMIUM") {
        return (
          <AuthButton {...buttonStyle} {...(parsedProps as ButtonProps)} />
        );
      } else {
        return (
          <SignInButton {...buttonStyle} {...(parsedProps as ButtonProps)} />
        );
      }
    default:
      return <div />;
  }
};

export * from "./button-link";
export * from "./open-modal";
export * from "./open-search";
